// extracted by mini-css-extract-plugin
export default {"wrapper":"nwNBx","image":"Vdso3","qr-code-wrap":"Q6ucJ","qr-code-image":"twSaV"};